import React from "react";
import { Link } from "react-router-dom";
import Button from "./Button";

const ButtonLink = ({ children, to, color = "primary", ...props }) => (
  <Button color={color} component={Link} to={to} {...props}>
    {children}
  </Button>
);

export default ButtonLink;



// WEBPACK FOOTER //
// ./src/components/Buttons/ButtonLink.js